<!-- Maybe Extract it to component -->
<div class="wrapping" *ngIf="showFilter">
  <app-filter-area [translateKey]="translateKey" [searchPlaceholder]="searchPlaceholder"
                   (filterChange)="filterChange.emit($event)" [searchFilter]="searchFilter" [sort]="sort"
                   (removeSort)="sortChange.emit(null)"
                   (onShowFilter)="onShowFilter.emit()" (onShowDeleted)="onShowDeleted.emit()"></app-filter-area>
</div>

@if(list.length === 0) {
  {{ 'page.home.is-empty' | translate }}
} @else {
  <div class="wrapping">
    <table>
      <tr class="head">
        <td *ngFor="let field of config.fields" (click)="sortIt(field)" [class.sortable]="sortable">
          {{ config.translateKey + field.param | translate }}
          <span *ngIf="sort && sort.field === field.param">
            <i class="fas" [class.fa-sort-up]="sort.sort === sortEnum.ASC"
               [class.fa-sort-down]="sort.sort === sortEnum.DESC"></i>
          </span>
        </td>
        <td *ngIf="config.actions"></td>
      </tr>
      @for (item of list; track item) {
        <tr class="table-row" cdkDrag (drop)="onDrop($event)">
          <td *ngFor="let field of config.fields" (click)="onClick(menuActionType.DETAIL,item)"
              keyBooleanTranslate="{{item[field.param]}}" typeBooleanTranslate="{{field.type}}">
            @if((field.param!='employee') && (field.type!='DATETIME')) {
              {{ item[field.param] }}
            } @else {
              <span *ngIf="(field.param=='employee')">{{ item[field.param]|firstLastName }}</span>
              <span *ngIf="(field.type=='DATETIME')">{{ item[field.param]|dateTinyExtra }}</span>
            }
          </td>
          <td *ngIf="config.actions" class="actions">
            @for(action of config.actions; track action) {
              @if(action.type === menuActionType.DELETE || action.type === menuActionType.SOFTDELETE|| action.type === menuActionType.ERASE) {
                <span class="action deleted"
                      (confirm)="onClick(action.type!, item)"
                      [confirmMessage]="action.confirmMessage"
                      [titleMessage]="action.titleMessage">
                  <i class="{{action.icon}}"></i>
                </span>
              } @else {
                <span class="action" (click)="onClick(action.type!, item)">
                  <i class="{{action.icon}}"></i>
                </span>
              }
            }
          </td>
        </tr>
      }
    </table>
  </div>
}
